jQuery(".search-bar__close").click(function(){
   jQuery(".header-top__search-bar").hide();
});
jQuery(".header--search").click(function(){
   jQuery(".header-top__search-bar").show();
});

jQuery(".header-top__menu_mobile").click(function(){
   jQuery(".header-top__menu").trigger('click');
});

jQuery(function(){
    createSticky(jQuery('#shopify-section-header'));
});
function createSticky(sticky) {
    if (typeof sticky !== "undefined") {
        var pos = sticky.offset().top,
            win = jQuery(window);
        var posnew = sticky.height();
        win.on("scroll", function() {
            if(win.scrollTop()==pos){
                sticky.removeClass("fixed");                
            }else{
                if(win.scrollTop() >= pos){
                    sticky.addClass("fixed");
                }else{
                    sticky.removeClass("fixed");   
                }
                if(win.scrollTop() >= posnew){
                  sticky.addClass("newclass");
                }else{
                  sticky.removeClass("newclass");
                }
            }
        });         
    }
}

/* =====================================
::: START ::: Featured Media Slider :::
===================================== */
$('.fmedia-slider').slick({
  infinite: true,
  autoplay: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><svg width="30" height="48" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.25 5.05937L24.4555 0.25L0.75 24L24.4555 47.75L29.25 42.9406L10.3539 24L29.25 5.05937Z" fill="#707070"/></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg width="30" height="48" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 5.05937L5.54453 0.25L29.25 24L5.54453 47.75L0.75 42.9406L19.6461 24L0.75 5.05937Z" fill="#707070"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

/* =====================================
::: END ::: Featured Media Slider :::
===================================== */

/* ===========================================
::: START ::: Featrued Brand :::
=========================================== */
$('.fblogo-grid').slick({
  infinite: false,
  slidesToShow: 4,
  autoplay: true,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><svg width="30" height="48" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.25 5.05937L24.4555 0.25L0.75 24L24.4555 47.75L29.25 42.9406L10.3539 24L29.25 5.05937Z" fill="#707070"/></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg width="30" height="48" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 5.05937L5.54453 0.25L29.25 24L5.54453 47.75L0.75 42.9406L19.6461 24L0.75 5.05937Z" fill="#707070"/></svg></button>',
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 992,
      settings: {
        centerMode: true,
        variableWidth: true,
        infinite: true,
      }
    }
  ]
});

/* ===========================================
::: End ::: Featrued Brand :::
=========================================== */


/* ===========================================
::: START ::: Advance Testimonials Slider :::
=========================================== */

$('.testimonials-slicks').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  dots: true,
  arrow: true,
  prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none"><g filter="url(#filter0_d_275_51)"><path d="M33.5 0C17.2086 0 4 13.2086 4 29.5C4 45.7914 17.2086 59 33.5 59C49.7914 59 63 45.7914 63 29.5C63 13.2086 49.7914 0 33.5 0ZM42.1804 46.6321L39.5733 49.2392L19.8304 29.5L39.5733 9.75712L42.1804 12.3642L25.0446 29.5L42.1804 46.6321Z" fill="white"/></g><defs><filter id="filter0_d_275_51" x="0" y="0" width="67" height="67" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_275_51"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_275_51" result="shape"/></filter></defs></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none"><g filter="url(#filter0_d_275_52)"><path d="M33.5 0C49.7914 0 63 13.2086 63 29.5C63 45.7914 49.7914 59 33.5 59C17.2086 59 4 45.7914 4 29.5C4 13.2086 17.2086 0 33.5 0ZM24.8196 46.6321L27.4267 49.2392L47.1696 29.5L27.4267 9.75712L24.8196 12.3642L41.9554 29.5L24.8196 46.6321Z" fill="white"/></g><defs><filter id="filter0_d_275_52" x="0" y="0" width="67" height="67" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_275_52"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_275_52" result="shape"/></filter></defs></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


var legthArr=[];
jQuery(document).ready(function(){
    jQuery('.testimonial-box').each(function() {
          var height = jQuery(this).outerHeight();
          legthArr.push(height); 
      });
      var maxValue = Math.max.apply(Math,legthArr);
      jQuery('.testimonial-box').each(function() {
          jQuery(this).css('height',maxValue);
      });
});

var legthBlogArr=[];
jQuery(document).ready(function(){
  jQuery('.article-grid__title').each(function() {
      var height = jQuery(this).outerHeight();
      legthBlogArr.push(height); 
  });
  var maxValue = Math.max.apply(Math,legthBlogArr);
  jQuery('.article-grid__title').each(function() {
      jQuery(this).css('height',maxValue);
  });
});

$('.videotestimonials-slicks').slick({
  infinite: true,
  autoplay: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  dots: false,
  arrow: true,
  prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none"><g filter="url(#filter0_d_275_51)"><path d="M33.5 0C17.2086 0 4 13.2086 4 29.5C4 45.7914 17.2086 59 33.5 59C49.7914 59 63 45.7914 63 29.5C63 13.2086 49.7914 0 33.5 0ZM42.1804 46.6321L39.5733 49.2392L19.8304 29.5L39.5733 9.75712L42.1804 12.3642L25.0446 29.5L42.1804 46.6321Z" fill="white"/></g><defs><filter id="filter0_d_275_51" x="0" y="0" width="67" height="67" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_275_51"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_275_51" result="shape"/></filter></defs></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none"><g filter="url(#filter0_d_275_52)"><path d="M33.5 0C49.7914 0 63 13.2086 63 29.5C63 45.7914 49.7914 59 33.5 59C17.2086 59 4 45.7914 4 29.5C4 13.2086 17.2086 0 33.5 0ZM24.8196 46.6321L27.4267 49.2392L47.1696 29.5L27.4267 9.75712L24.8196 12.3642L41.9554 29.5L24.8196 46.6321Z" fill="white"/></g><defs><filter id="filter0_d_275_52" x="0" y="0" width="67" height="67" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_275_52"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_275_52" result="shape"/></filter></defs></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

//buy now button click on home page to scroll particuler section smooth scroll

/* jQuery('.slide__button').click(function(event){
      event.preventDefault();
      $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top
      }, 1500);
}); */

//video play icon click to autoplay code start here
$(document).ready(function () {
  $(".vtestimonials-playicon").on("click", function () {
      var videoType = $(this).data("video-type");
      var videoPlayer = $(this).parent().parent('div');
      videoPlayer=videoPlayer.find(".video-player")[0];
      $(this).parent().parent('div').find('.video--localurl').show();
      if(videoType === 'normal') {
        // For normal videos, play/pause directly
        if (videoPlayer.paused) {
          videoPlayer.play();
        } else {
          videoPlayer.pause();
        }
      }
  });
});
// end video play code
/* =========================================
::: END ::: Advance Testimonials Slider :::
========================================= */	

/* =========================================
::: START ::: Advance Featrued Blog :::
========================================= */

$('.blog-featured-slick').slick({
  infinite: true,
  slidesToShow: 3,
  autoplay: true,
  slidesToScroll: 1,
  dots: true,
  arrow: true,
  prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none"><g filter="url(#filter0_d_275_51)"><path d="M33.5 0C17.2086 0 4 13.2086 4 29.5C4 45.7914 17.2086 59 33.5 59C49.7914 59 63 45.7914 63 29.5C63 13.2086 49.7914 0 33.5 0ZM42.1804 46.6321L39.5733 49.2392L19.8304 29.5L39.5733 9.75712L42.1804 12.3642L25.0446 29.5L42.1804 46.6321Z" fill="white"/></g><defs><filter id="filter0_d_275_51" x="0" y="0" width="67" height="67" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_275_51"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_275_51" result="shape"/></filter></defs></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 67 67" fill="none"><g filter="url(#filter0_d_275_52)"><path d="M33.5 0C49.7914 0 63 13.2086 63 29.5C63 45.7914 49.7914 59 33.5 59C17.2086 59 4 45.7914 4 29.5C4 13.2086 17.2086 0 33.5 0ZM24.8196 46.6321L27.4267 49.2392L47.1696 29.5L27.4267 9.75712L24.8196 12.3642L41.9554 29.5L24.8196 46.6321Z" fill="white"/></g><defs><filter id="filter0_d_275_52" x="0" y="0" width="67" height="67" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_275_52"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_275_52" result="shape"/></filter></defs></svg></button>',
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

var legthArr=[];
jQuery(document).ready(function(){
    jQuery('.blog-featured-box').each(function() {
          var height = jQuery(this).outerHeight();
          legthArr.push(height); 
      });
      var maxValue = Math.max.apply(Math,legthArr);
      jQuery('.blog-featured-box').each(function() {
          jQuery(this).css('height',maxValue);
      });
});

/* =========================================
::: END ::: Advance Featrued Blog :::
========================================= */


$(document).on('click','.product-form__submit',function(e){
  e.preventDefault();
  e.stopPropagation();
  $(this).find(".btn-txt").text("Adding...");
  var ID = $('#advFeaturId').val(); 
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: $('.quantity__input').val(),
      id: ID
    },
    dataType: 'json', 
    success: function (data) {
      window.location.href="/checkout";
    } 
  });
}) 


/* =========================================
::: START ::: Advance FAQs :::
========================================= */

$(document).ready(function(){
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');
		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');
		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})
})

$(document).ready(function() {
  $(".accordian > .accordian-heading").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".accordian-content")
        .slideUp(200);
      $(".accordian > .accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".accordian > .accordian-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".accordian > .accordian-heading").removeClass("active");
      $(this).addClass("active");
      $(".accordian-content").slideUp(200);
      $(this)
        .siblings(".accordian-content")
        .slideDown(200);
    }
  });
});

/* =========================================
::: END ::: Advance FAQs :::
========================================= */
/* =========================================
::: START ::: Advance Adv ICON TEXT :::
========================================= */

$('.icontext-grid').slick({
  infinite: true,
  autoplay: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><svg width="30" height="48" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.25 5.05937L24.4555 0.25L0.75 24L24.4555 47.75L29.25 42.9406L10.3539 24L29.25 5.05937Z" fill="#707070"/></svg></button>',
  nextArrow: '<button class="slick-next slick-arrow"><svg width="30" height="48" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 5.05937L5.54453 0.25L29.25 24L5.54453 47.75L0.75 42.9406L19.6461 24L0.75 5.05937Z" fill="#707070"/></svg></button>',
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick"
    },
    {
      breakpoint: 803,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 715,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

/* =========================================
::: END ::: Advance Adv ICON TEXT :::
========================================= */

$(document).ready(function(){
	$('.description-tabs .tab__title').click(function(){
		var tab_id = $(this).attr('data-tab');
		$('.description-tabs .tab__title').removeClass('current');
		$('.product__tab--description').removeClass('current');
		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	});

  $(".custom-size-button").on("click",function(e){
    e.preventDefault();
    $(".size-chart-popup").addClass("active");
  });

  $(".size-close-popup,.size-chart-popup-overlay").on("click",function(e){
    e.preventDefault();
    $(".size-chart-popup").removeClass("active");
  });
});


// Header Fix 

// 	sticky header 

	jQuery(document).ready(function(){
      jQuery('.index  .header-primary__logo_S ').hide();

	jQuery(window).on("scroll", function(){
		if(jQuery(window).scrollTop()){
			jQuery('.index .section__header .header-wrapper').addClass('sticky');
           jQuery('.index  .header-primary__logo_S ').show();
          jQuery('.index  .header-primary__logo ').hide();
         
		}
	else{
		jQuery('.index .section__header .header-wrapper').removeClass('sticky');
   jQuery('.index  .header-primary__logo ').show();
	}
	});
});

